export const formatCents = (cents: number | null | undefined, currency: string): string => {
  const value = (cents || 0) / 100;
  return new Intl.NumberFormat(currency === 'BRL' ? 'pt-BR' : 'en-US', {
    style: 'currency',
    currency,
  }).format(value);
};

export const formatExactCents = (cents: string | bigint, currency: string): string => {
  const canonicalCents = typeof cents === 'bigint' ? cents.toString() : cents;
  if (!/^(0|[1-9][0-9]*)$/.test(canonicalCents)) {
    throw new RangeError('Cents must be a canonical nonnegative integer.');
  }

  const integerCents = BigInt(canonicalCents);
  const majorUnits = integerCents / 100n;
  const fraction = (integerCents % 100n).toString().padStart(2, '0');
  const formatter = new Intl.NumberFormat(currency === 'BRL' ? 'pt-BR' : 'en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.formatToParts(majorUnits)
    .map((part) => (part.type === 'fraction' ? fraction : part.value))
    .join('');
};
